import React from 'react'

const BasePage = (props) => (
  <div className="wrapper" id="page-wrap">
    {props.children}
  </div>
)

export default BasePage
